import React from "react";
import GroupPopup from "../SideBar/Results/GroupPopup";
import { FaFilter } from "react-icons/fa";
import { useSelector } from "react-redux";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { FcCheckmark, FcCancel } from "react-icons/fc";

const GridHeader = ({
    toggleFilter,
    filterToggle,
    excelExport,
    selectedTab,
    handleTabSelect,
    saveChanges,
    cancelChanges,
    changes,
    length,
}) => {
    const results = useSelector((state) => state.resultsData.results);

    // Title for tabstrip
    const Title = ({ name, results }) => {
        return (
            <>
                {" "}
                <div>{name}</div>
                <GroupPopup results={results} />
            </>
        );
    };

    const EditButtons = ({ saveChanges, cancelChanges }) => {
        return (
            <div className="grid-edit-buttons">
                <div onClick={saveChanges} className="grid-edit-button">
                    <FcCheckmark style={{ width: "20px", height: "100%" }} />
                    Save
                </div>
                <div onClick={cancelChanges} className="grid-edit-button">
                    <FcCancel style={{ width: "20px", height: "100%" }} />
                    Cancel
                </div>
            </div>
        );
    };

    return (
        <div className="grid-panel-top">
            <div className="grid-toolbar">
                {changes && (
                    <EditButtons
                        saveChanges={saveChanges}
                        cancelChanges={cancelChanges}
                    />
                )}
                <div className="grid-title">
                    Results {length !== undefined && `(${length})`}
                </div>

                <div className="grid-options">
                    <nav
                        className={`grid-option ${filterToggle ? "selected" : ""}`}
                        title="Filter">
                        <FaFilter
                            onClick={toggleFilter}
                            style={{
                                paddingRight: "5px",
                                display: "flex",
                                width: "15px",
                            }}
                        />
                    </nav>
                    <nav
                        className="grid-option"
                        onClick={excelExport}
                        title="Export to Excel">
                        <span
                            className="k-icon k-i-file-excel"
                            style={{ paddingRight: "5px" }}></span>
                    </nav>
                    <GroupPopup results={results} icon="menu" />
                </div>
            </div>
            <TabStrip selected={selectedTab} onSelect={handleTabSelect}>
                {results.map((r) => {
                    return (
                        <TabStripTab
                            title={<Title results={[r]} name={r.DisplayName} />}
                            key={r.Id}
                            disabled={changes}></TabStripTab>
                    );
                })}
            </TabStrip>
        </div>
    );
};

export default GridHeader;
